import React from "react";

import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Box, useMantineTheme } from "@mantine/core";
import { useMediaQuery } from '@mantine/hooks';

import ListContent from "./ListContent";
import ListPost from "./ListPost";
import GridPost from "./GridPost";

import { getRoot } from "../../../utils/Host";
import { setTiptapSidemenu } from "../../../store/app";

export default function SpaceListItem(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const theme = useMantineTheme();

  const mediumScreen = useMediaQuery(`(max-width: ${theme.other.breakpoints.md}px)`);

  const spaceFilterSettings = Array.isArray(props.spaceFilterSettings) ? props.spaceFilterSettings : [];
  const space_filters = Array.isArray(props.space?.space_filters) ? props.space.space_filters : [];
  const space_filters_data = spaceFilterSettings.map((f) => {
    const selectedFilter = space_filters.find((f2) => f2.id === f.id);
    let _value = selectedFilter?.value || "";
    if (["string", "number"].includes(typeof _value)) {
      _value = String(_value);
    } else if (["select", "multi_select"].includes(f.format) && Array.isArray(selectedFilter?.value)) {
      _value = _value.map((v) => String(v));
    } else if (f.format === "location" && typeof _value === "string") {
      _value = _value.length > 0 ? { formatted: _value } : null;
    }
    return {
      ...f,
      value: _value,
      space_filter_id: selectedFilter?.space_filter_id
    };
  });

  const getLink = () => {
    if (props.space.version) {
      return `/space/${props.space.slug}/${props.space.version}`;
    } else {
      return `/space/${props.space.slug}`;
    }
  };

  const goToLink = () => {
    if (props.space.is_linked) {
      window.open(`${getRoot()}${getLink()}`, "_blank");
    } else if (props.openInModal && !mediumScreen) {
      
      dispatch(
        setTiptapSidemenu({ opened: "space-content", option: props.space.slug })
      );
      
    } else {
      window.location = `${getRoot()}${getLink()}`;
      // navigate(getLink());
    }
  };

  return (
    <>
      {props.noLink ? (
        <Box
          component={Link}
          to={getLink()}
          sx={{
            height: props.viewAs == "grid" ? "100%" : "",
            "&:hover": {
              textDecoration: "none",
            },
          }}
        >
          {!props.viewAs && <ListContent space={props.space} lineClamp={props.lineClamp} />}
          {props.viewAs == "post" && <ListPost space={props.space} lineClamp={props.lineClamp} />}
          {props.viewAs == "grid" && <GridPost space={props.space} lineClamp={props.lineClamp} />}
          {props.viewAs == "card" && <GridPost space={props.space} lineClamp={props.lineClamp} />}
          {props.viewAs == "link" && `${getRoot()}${getLink()}`}
        </Box>
      ) : (
        <Box
          onClick={(event) => goToLink()}
          sx={{
            height: props.viewAs == "grid" ? "100%" : "",
            "&:hover": {
              textDecoration: "none",
            },
          }}
        >
          {!props.viewAs && <ListContent space={props.space} lineClamp={props.lineClamp} styleTitle={props.styleTitle} />}
          {props.viewAs == "post" && (
            <ListPost
              space={props.space}
              onUpdate={props.onUpdate}
              showAuthor={props.showAuthor}
              canPin={props.canPin}
              {...props.settings}
              onDuplicate={props.onDuplicate}
              lineClamp={props.lineClamp}
              space_filters={space_filters_data}
            />
          )}
          {props.viewAs == "grid" && (
            <GridPost
              space={props.space}
              onUpdate={props.onUpdate}
              showAuthor={props.showAuthor}
              canPin={props.canPin}
              {...props.settings}
              onDuplicate={props.onDuplicate}
              lineClamp={props.lineClamp}
              space_filters={space_filters_data}
            />
          )}
          {props.viewAs == "card" && (
            <GridPost
              space={props.space}
              onUpdate={props.onUpdate}
              showAuthor={props.showAuthor}
              canPin={props.canPin}
              {...props.settings}
              onDuplicate={props.onDuplicate}
              lineClamp={props.lineClamp}
              space_filters={space_filters_data}
            />
          )}
          {props.viewAs == "link" && (
            `${getRoot()}${getLink()}`
          )}
        </Box>
      )}
    </>
  );
}
